import React from "react";
import AchievementsTeamsLiveUpdate from "../List/LiveUpdateContainer";
import { FormattedMessage } from "react-intl";

const resultPartsToShow = [
  "result-part--achievements-teams",
];

const LiveUpdatePanel = ({ result, marked, matches }) => {
  if (!result) return null;

  let parts = result.parts.filter((part) =>
    resultPartsToShow.includes(part.type) || result.showLiveUpdate
  );

  if (!parts.length) {
    return null;
  }

  return (
    <div className="live-update">
      <FormattedMessage id="liveUpdate.title">
        {(message) => (
          <Panel name={message}>
            <div className="live-update__hint">
              <FormattedMessage id="liveUpdate.hintHighlight" />
            </div>
            <section className="live-update__content">
              {parts.map((part) => (
                <AchievementsTeamsLiveUpdate
                  key={part.type}
                  {...part}
                  marked={marked}
                  matches={matches}
                />
              ))}
            </section>
          </Panel>
        )}
      </FormattedMessage>
    </div>
  );
};

const Panel = ({ name, children }) => (
  <section className="module live-update-module">
    <header className="module__header">
      <h2 className="module__title">{name}</h2>
    </header>
    {children}
  </section>
);

export default LiveUpdatePanel;
